"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var use_ssr_1 = __importDefault(require("use-ssr"));
/**
 * Used for error checking. If the condition is false, throw an error
 */
function invariant(condition, format, a, b, c, d, e, f) {
    if (a === void 0) { a = ''; }
    if (b === void 0) { b = ''; }
    if (c === void 0) { c = ''; }
    if (d === void 0) { d = ''; }
    if (e === void 0) { e = ''; }
    if (f === void 0) { f = ''; }
    if (process.env.NODE_ENV !== 'production') {
        if (format === undefined) {
            throw new Error('invariant requires an error message argument');
        }
    }
    if (!condition) {
        var error = void 0;
        if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' +
                'for the full error message and additional helpful warnings.');
        }
        else {
            var args_1 = [a, b, c, d, e, f];
            var argIndex_1 = 0;
            error = new Error(format.replace(/%s/g, function () { return args_1[argIndex_1++]; }));
            error.name = 'Invariant Violation';
        }
        throw error;
    }
}
exports.invariant = invariant;
exports.useExampleURL = function () {
    var isBrowser = use_ssr_1.default().isBrowser;
    return react_1.useMemo(function () {
        return isBrowser ? window.location.origin : 'https://example.com';
    }, [isBrowser]);
};
function useURLRequiredInvariant(condition, method, optionalMessage) {
    var exampleURL = exports.useExampleURL();
    react_1.useEffect(function () {
        invariant(condition, method + " requires a URL to be set as the 1st argument,\n\n      unless you wrap your app like:\n\n      <Provider url=\"" + exampleURL + "\"><App /></Provider>\n\n      " + optionalMessage);
    }, [condition, exampleURL, method, optionalMessage]);
}
exports.useURLRequiredInvariant = useURLRequiredInvariant;
exports.isString = function (x) { return typeof x === 'string'; }; // eslint-disable-line
/**
 * Determines if the given param is an object. {}
 * @param obj
 */
exports.isObject = function (obj) { return Object.prototype.toString.call(obj) === '[object Object]'; }; // eslint-disable-line
/**
 * Determines if the given param is an object that can be used as a request body.
 * Returns true for native objects or arrays.
 * @param obj
 */
exports.isBodyObject = function (obj) { return exports.isObject(obj) || Array.isArray(obj); };
exports.isFunction = function (v) { return typeof v === 'function'; };
// const requestFields = Object.getOwnPropertyNames(Object.getPrototypeOf(new Request('')))
// const responseFields = Object.getOwnPropertyNames(Object.getPrototypeOf(new Response()))
// export const customResponseFields = [...responseFields, 'data']
// TODO: come back and fix the "anys" in this http://bit.ly/2Lm3OLi
/**
 * Makes an object that will match the standards of a normal fetch's options
 * aka: pulls out all useFetch's special options like "onMount"
 */
exports.pullOutRequestInit = function (options) {
    if (!options)
        return {};
    var requestInitFields = [
        'body',
        'cache',
        'credentials',
        'headers',
        'integrity',
        'keepalive',
        'method',
        'mode',
        'redirect',
        'referrer',
        'referrerPolicy',
        'signal',
        'window'
    ];
    return requestInitFields.reduce(function (acc, key) {
        if (key in options)
            acc[key] = options[key];
        return acc;
    }, {});
};
exports.isEmpty = function (x) { return x === undefined || x === null; };
var Device;
(function (Device) {
    Device["Browser"] = "browser";
    Device["Server"] = "server";
    Device["Native"] = "native";
})(Device = exports.Device || (exports.Device = {}));
var Browser = Device.Browser, Server = Device.Server, Native = Device.Native;
var canUseDOM = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
var canUseNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
var device = canUseNative ? Native : canUseDOM ? Browser : Server;
exports.isBrowser = device === Browser;
exports.isServer = device === Server;
exports.isNative = device === Native;
exports.tryGetData = function (res, defaultData) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data, er_1, er_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof res === 'undefined')
                    throw Error('Response cannot be undefined... 😵');
                response = res.clone();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 8]);
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [3 /*break*/, 8];
            case 3:
                er_1 = _a.sent();
                _a.label = 4;
            case 4:
                _a.trys.push([4, 6, , 7]);
                return [4 /*yield*/, response.text()];
            case 5:
                data = (_a.sent()); // FIXME: should not be `any` type
                return [3 /*break*/, 7];
            case 6:
                er_2 = _a.sent();
                return [3 /*break*/, 7];
            case 7: return [3 /*break*/, 8];
            case 8: return [2 /*return*/, (defaultData && exports.isEmpty(data)) ? defaultData : data];
        }
    });
}); };
exports.responseFields = ['headers', 'ok', 'redirected', 'trailer', 'status', 'statusText', 'type', 'url', 'body', 'bodyUsed', 'data'];
exports.responseMethods = ['clone', 'arrayBuffer', 'blob', 'formData', 'json', 'text'];
exports.responseKeys = __spreadArrays(exports.responseFields, exports.responseMethods);
exports.emptyCustomResponse = Object.defineProperties({}, exports.responseKeys.reduce(function (acc, field) {
    if (exports.responseFields.includes(field)) {
        acc[field] = {
            get: function () { },
            enumerable: true
        };
    }
    else if (exports.responseMethods.includes(field)) {
        acc[field] = {
            value: function () { },
            enumerable: true
        };
    }
    return acc;
}, {}));
//# sourceMappingURL=utils.js.map